import { render, staticRenderFns } from "./pim-chart.vue?vue&type=template&id=1aaf3a02&scoped=true&"
import script from "./pim-chart.vue?vue&type=script&lang=js&"
export * from "./pim-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf3a02",
  null
  
)

export default component.exports